import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Bgtwo from '../../assets/images/background/image-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Controller } from 'swiper/modules';
import 'swiper/css';

function Contact() {

    const [firstSwiper, setFirstSwiper] = useState(null);
    const [secondSwiper, setSecondSwiper] = useState(null);

    const [flag, setflag] = useState(false)

    const slider2 = useRef()
    const duration = 500;
    const syncPosition = (e) => {
        if (!flag) {
            setflag(false)
            if (slider2.current) {
                slider2.current.to(e.item.index, duration)
            }
            setflag(false)
        }
    }

    return (
        <>
            <div className="testimonials-section" >
                <div className="image-layer" style={{ backgroundImage: `url(${Bgtwo})` }}></div>
                <div className="auto-container">
                    <div className="carousel-box owl-theme">
                        <Swiper className="testi-top"
                            modules={[Controller]}
                            onSwiper={setFirstSwiper}
                            controller={{ control: secondSwiper }}
                            items={1} loop margin={10} autoplay onChange={(e) => syncPosition(e)}>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Pizza je neverovatna, najbolja u Smederevu! Tortilje su takođe odlične, a dostava je uvek brza. Bon Appetit je naš prvi izbor za porodične večere!</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Pored odlične hrane, ovde se osećaš kao kod kuće. Sve je čisto i uredno, osoblje je ljubazno, a ambijent je prijatan. Vraćam se uvek sa zadovoljstvom!</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Prava kulinarska čarolija! Svako jelo je bilo savršeno začinjeno i pripremljeno sa pažnjom. Bon Appetit je zaista opravdao svoje ime - nezaboravno iskustvo!</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Oduševljen sam raznovrsnom ponudom! Od pizza do tortilja, sve je uvek sveže i ukusno. Posebno preporučujem njihovu Srpsku picu i hrskavu piletinu.</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Naručujemo redovno već mesecima i svaki put nas oduševe. Sastojci su kvalitetni, porcije su obilne, a odnos cene i kvaliteta je izvanredan!</div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="slide-item">
                                <div className="slide-content">
                                    <div className="quotes">"</div>
                                    <div className="text quote-text">Najbolja picerija u Smederevu! Hrana je fantastična, dostava brza, a cene pristupačne. Svaka preporuka!</div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <div className="separator"><span></span><span></span><span></span></div>
                        <div className="thumbs-carousel-box">
                            <Swiper 
                                className="testi-thumbs" 
                                modules={[Controller]}
                                onSwiper={setSecondSwiper}
                                controller={{ control: firstSwiper }}
                                loop={true} 
                                autoplay={true}
                            >
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author1} alt="" />
                                    </div> */}
                                    <div className="auth-title">Marko Jovanović</div>
                                </SwiperSlide>
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author2} alt="" />
                                    </div> */}
                                    <div className="auth-title">Ana Petrović</div>
                                </SwiperSlide>
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author3} alt="" />
                                    </div> */}
                                    <div className="auth-title">Stefan Nikolić</div>
                                </SwiperSlide>
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author1} alt="" />
                                    </div> */}
                                    <div className="auth-title">Milica Đorđević</div>
                                </SwiperSlide>
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author2} alt="" />
                                    </div> */}
                                    <div className="auth-title">Nikola Stanković</div>
                                </SwiperSlide>
                                <SwiperSlide className="slide-item">
                                    {/* <div className="image">
                                        <img src={author3} alt="" />
                                    </div> */}
                                    <div className="auth-title">Jelena Ilić</div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>

            <section className="reserve-section">
                <div className="auto-container">
                    <div className="outer-box">
                        <div className="row clearfix">
                            <div className="reserv-col col-lg-12 col-md-12 col-sm-12">
                                <div className="inner">
                                    <div className="title">
                                        <h2>Naručite Odmah</h2>
                                        <div className="request-info">Pozovite nas na <Link to="tel:+381641856290">+381 64 1856 290</Link> ili naručite preko Glovo aplikacije</div>
                                    </div>
                                    <div className="default-form reservation-form">
                                        <div className="row clearfix">
                                            <div className="form-group col-lg-12 col-md-12 col-sm-12">
                                                <div className="field-inner" style={{border: 'none', padding: '20px 0'}}>
                                                    <h3 style={{marginBottom: '20px'}}>Kako Da Naručite?</h3>
                                                    <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '15px'}}>
                                                        Naručivanje je jednostavno i brzo! Izaberite način koji vam najviše odgovara:
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div className="form-group col-lg-6 col-md-6 col-sm-12">
                                                <div className="field-inner" style={{textAlign: 'center', padding: '30px'}}>
                                                    <i className="fas fa-phone" style={{fontSize: '48px', color: '#c7a17a', marginBottom: '15px'}}></i>
                                                    <h4 style={{marginBottom: '10px'}}>Telefonski</h4>
                                                    <p>Pozovite nas direktno i naručite</p>
                                                    <Link to="tel:+381641856290" style={{fontSize: '20px', fontWeight: 'bold', color: '#c7a17a'}}>
                                                        +381 64 1856 290
                                                    </Link>
                                                </div>
                                            </div>
                                            
                                            <div className="form-group col-lg-6 col-md-6 col-sm-12">
                                                <div className="field-inner" style={{textAlign: 'center', padding: '30px'}}>
                                                    <i className="fas fa-mobile-alt" style={{fontSize: '48px', color: '#c7a17a', marginBottom: '15px'}}></i>
                                                    <h4 style={{marginBottom: '10px'}}>Glovo Aplikacija</h4>
                                                    <p>Naručite online sa lakoćom</p>
                                                    <a href="https://glovoapp.com/rs/en/smederevo/bon-appetit-smd/" target="_blank" rel="noopener noreferrer" 
                                                    style={{fontSize: '16px', fontWeight: 'bold', color: '#c7a17a'}}>
                                                        Naruči sada
                                                    </a>
                                                </div>
                                            </div>
                                            
                                            <div className="form-group col-lg-12 col-md-12 col-sm-12">
                                                <div className="field-inner" style={{border: 'none', padding: '20px'}}>
                                                    <h4 style={{marginBottom: '15px'}}>Radno Vreme</h4>
                                                    <p style={{fontSize: '16px', marginBottom: '5px'}}>
                                                        <strong>Ponedeljak - Subota:</strong> 08:00 - 22:30
                                                    </p>
                                                    <p style={{fontSize: '16px'}}>
                                                        <strong>Nedelja:</strong> Zatvoreno
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div className="form-group col-lg-12 col-md-12 col-sm-12">
                                                <div className="field-inner">
                                                    <Link to="/menu" className="theme-btn btn-style-one clearfix">
                                                        <span className="btn-wrap">
                                                            <span className="text-one">pogledajte meni</span>
                                                            <span className="text-two">pogledajte meni</span>
                                                        </span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="info-col col-lg-4 col-md-12 col-sm-12">
                                <div className="inner">
                                    <div className="title">
                                        <h2>Kontaktirajte nas</h2>
                                    </div>
                                    <div className="data">
                                        <div className="booking-info">
                                            <div className="bk-title">Pozovite za narudžbinu</div>
                                            <div className="bk-no"><Link to="tel:+381641856290">+381 64 1856 290</Link></div>
                                        </div>
                                        <div className="separator"><span></span></div>
                                        <ul className="info">
                                            <li><strong>Lokacija</strong><br />Ivana Gundulića 7, lokal 1<br />Smederevo 230437</li>
                                            <li><strong>Radno Vreme</strong><br />Ponedeljak - Subota<br />08:00 - 22:30</li>
                                            <li><strong>Nedelja</strong><br />Zatvoreno</li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact